export default "__VITE_ASSET__CCXnq8fd__"